export default __webpack_public_path__ + "static/media/slack.9bbbca15.svg";